<!-- <app-header #header></app-header> -->
<div class="main">
  <div class="content">
    <div>
      <div class="profile-card">
        <app-profile-card1></app-profile-card1>
      </div>
      <app-learnings1></app-learnings1>
    </div>
    <div >
      <div class="announce">
        <app-announcements1></app-announcements1>
     <div class="next">
      <app-learn-next1></app-learn-next1>
    </div>
    </div>
      
    </div>
  </div> 
</div>




